export default {
	"helpers.OnlyTheBeginningIsLeft": "Only the beginning is left",
	"helpers.OnlyTheEndRemains": "Only the end remains",
	"helpers.ThePurchaseQuantityCannotBe0": "The purchase quantity cannot be 0",
	"helpers.prompt": "prompt",
	"helpers.UntieTheBindingForTheTimeBeing": "Untie the binding for the time being",
	"helpers.UnbindTheAccount": "Unbind the account",
	"helpers.SorryThePriceHasChanged": "Sorry, the price has changed!",
	"helpers.SorryTheVerificationFailed": "Sorry, the verification failed!",
	"helpers.YouHaveAnActivatedItem": "You have an activated item",
	"helpers.YouHaveSubscribedToTheItem": "You have subscribed to the item",
	"helpers.PurchasesAreNotCurrentlyAvailableForThisItem": "Purchases are not currently available for this item"
}